/* Email pop-up: opens once after a short delay, remembers it was closed, closes with X / Esc / outside click.
   Without this file the pop-up stays hidden and the page works as normal. */
(function () {
  'use strict';

  var KEY = 'cc-popup';
  var pop = document.querySelector('[data-email-popup]');
  if (!pop) return;

  var card = pop.querySelector('.epop__card');
  var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 5) * 1000;
  var days = parseInt(pop.getAttribute('data-days'), 10) || 30;
  var forced = /[?&]popup=1\b/.test(location.search);
  var design = pop.getAttribute('data-design-mode') === 'true';
  var posted = !!pop.querySelector('[data-popup-posted]');
  var opener = null;
  var timer = null;

  function remembered() {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      return !!saved && Date.now() - saved.t < days * 864e5;
    } catch (e) { return false; }
  }
  function remember(why) {
    try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), why: why })); } catch (e) { /* private mode: it may show again next visit */ }
  }

  function bagOpen() { return !!document.querySelector('dialog[open]'); }

  function open() {
    if (!pop.hidden) return;
    if (bagOpen()) { timer = setTimeout(open, 2000); return; }
    opener = document.activeElement;
    pop.hidden = false;
    document.documentElement.classList.add('epop-lock');
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
    var first = pop.querySelector('[data-popup-email]') || card;
    first.focus({ preventScroll: true });
  }

  function close(why) {
    if (pop.hidden) return;
    clearTimeout(timer);
    if (why !== 'preview') remember(why || 'closed');
    pop.classList.remove('is-open');
    document.documentElement.classList.remove('epop-lock');
    setTimeout(function () { pop.hidden = true; }, 180);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  pop.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-popup-close]')) close(forced ? 'preview' : 'closed');
  });

  document.addEventListener('keydown', function (e) {
    if (pop.hidden) return;
    if (e.key === 'Escape') { close(forced ? 'preview' : 'closed'); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(card.querySelectorAll('a[href], button, input'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Send the form without leaving the page. If that fails the form still posts the normal way. */
  var form = pop.querySelector('form');
  if (form && window.fetch && window.FormData) {
    form.addEventListener('submit', function (e) {
      var email = form.querySelector('[data-popup-email]');
      var consent = form.querySelector('[data-popup-consent]');
      var error = form.querySelector('[data-popup-error]');
      if (!email) return;
      e.preventDefault();
      var good = email.value.indexOf('@') > 0 && consent.checked;
      error.hidden = good;
      email.setAttribute('aria-invalid', good ? 'false' : 'true');
      if (!good) { (email.value.indexOf('@') > 0 ? consent : email).focus(); return; }
      var btn = form.querySelector('[data-popup-submit]');
      btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok || !/customer_posted=true/.test(res.url)) throw new Error('not saved');
          remember('subscribed');
          form.querySelector('[data-popup-ask]').hidden = true;
          var done = form.querySelector('[data-popup-done]');
          done.hidden = false;
          card.focus();
        })
        .catch(function () { error.hidden = false; btn.disabled = false; });
    });
  }

  if (posted) { remember('subscribed'); open(); return; }
  if (forced || design) { open(); return; }
  var path = location.pathname;
  if (remembered() || /^\/(cart|checkout|account)/.test(path)) return;
  timer = setTimeout(open, delay);
  /* A small scroll shows it sooner, but never later than the delay. */
  if (pop.getAttribute('data-scroll') === 'true') {
    var onScroll = function () {
      if (window.pageYOffset < 80) return;
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timer);
      open();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
